import { message, Button, Form } from "antd";
import { useEffect, useState } from "react";
import { useGlobalState } from "../../components/global";
import ContentImageUploader from "../components/ContentImageUploader";
import CustomQuill from "../components/CustomQuill";

export default function UserAgreement() {
    const { jsonRequest } = useGlobalState();
    const [form] = Form.useForm();
    const [platform, setPlatform] = useState<'ANDROID' | 'IOS'>('ANDROID');
    const [agreementType, setAgreementType] = useState<string>('USER_AGREEMENT');
    const [loading, setLoading] = useState(false);

    const imgUploadApi = async (fd: any) => {
        const OSSData = await getOSSData();
        return await ContentImageUploader(jsonRequest, fd.get('file'), OSSData);
    }

    const getOSSData = async () => {
        const result = await jsonRequest.get("/common/oss-sign", {
            type: "picture",
        }).then((resp: any) => resp.json());
        return result.data;
    };

    useEffect(() => {
        handleLoadData(platform, agreementType);
    }, [platform, agreementType]);

    const handleLoadData = async (platform: 'ANDROID' | 'IOS', type: string) => {
        setLoading(true);
        try {
            let response;
            if (type === 'USER_AGREEMENT' || type === 'PRIVACY_POLICY') {
                response = await jsonRequest.get("/back/other/user-agreement-privacy-policy", {
                    deviceType: platform,
                    type: type
                });
            } else {
                response = await jsonRequest.get("/back/other/rich-text", {
                    deviceType: platform,
                    type: type
                });
            }
            form.setFieldsValue({
                content: response.body.data || ''
            });
        } catch (error) {
            console.error("加载数据失败:", error);
            form.setFieldsValue({
                content: ''
            });
        } finally {
            setLoading(false);
        }
    }

    const handleSubmit = async (values: any) => {
        try {
            // 处理 content 中的图片 URL
            if (values?.content) {
                values.content = values.content.replace(/(src="[^?"]+)(?:\?[^"]+)?/g, '$1');
            }
            let result;
            if (agreementType === 'USER_AGREEMENT' || agreementType === 'PRIVACY_POLICY') {
                result = await jsonRequest.put(`/back/other/user-agreement-privacy-policy`, {
                    deviceType: platform,
                    type: agreementType,
                    content: values.content
                }).then((resp: any) => resp.json());
            } else {
                result = await jsonRequest.put(`/back/other/rich-text`, {
                    deviceType: platform,
                    type: agreementType,
                    content: values.content
                }).then((resp: any) => resp.json());
            }
            form.resetFields();
            if (result?.code !== 0) {
                message.error(result?.data?.msg || "保存失败");
                return;
            }
            message.success("保存成功");
            handleLoadData(platform, agreementType);
        } catch (error) {
            message.error("保存失败: " + (error as Error).message);
        }
    }

    const platformTabs = [
        {
            key: 'ANDROID',
            label: 'Android',
        },
        {
            key: 'IOS',
            label: 'IOS',
        },
    ];

    const agreementTabs = [
        {
            key: 'USER_AGREEMENT',
            label: '用户协议',
        },
        {
            key: 'PRIVACY_POLICY',
            label: '隐私政策',
        },
        {
            key: 'RICH_TEXT_VIP_SERVICE',
            label: '会员服务',
        },
        {
            key: 'RICH_TEXT_AUTOMATIC_RENEWAL',
            label: '自动续费',
        },
    ];

    const onPlatformChange = (key: string) => {
        setPlatform(key as 'ANDROID' | 'IOS');
    };

    const onAgreementChange = (key: string) => {
        setAgreementType(key);
    };

    return (
        <div>
            <h1>协议配置</h1>
            <div style={{ marginBottom: 20 }}>
                {platformTabs.map((tab) => (
                    <Button
                        key={tab.key}
                        type={platform === tab.key ? 'primary' : 'default'}
                        onClick={() => onPlatformChange(tab.key)}
                        style={{ marginRight: 8 }}
                    >
                        {tab.label}
                    </Button>
                ))}
            </div>
            <div style={{ marginBottom: 20 }}>
                {agreementTabs.map((tab) => (
                    <Button
                        key={tab.key}
                        type={agreementType === tab.key ? 'primary' : 'default'}
                        onClick={() => onAgreementChange(tab.key)}
                        style={{ marginRight: 8 }}
                    >
                        {tab.label}
                    </Button>
                ))}
            </div>

            <Form form={form} className="QuestionBankForm" onFinish={handleSubmit}>
                <Form.Item name="content" rules={[{ required: true, message: '不能为空' }]} style={{ height: 370 }}>
                    <CustomQuill
                        key={`${platform}-${agreementType}`}
                        style={{ height: 300 }}
                        imgUploadApi={imgUploadApi}
                        placeholder={"请填写内容"}
                        extendSize={["20px", "22px", "24px"]}
                        className="RichText"
                        readOnly={loading}
                    />
                </Form.Item>
                <Form.Item wrapperCol={{ span: 24 }} style={{ textAlign: 'center', marginTop: 16 }}>
                    <Button type="primary" htmlType="submit" size="large" loading={loading}>
                        保存
                    </Button>
                </Form.Item>
            </Form>
        </div>
    )
}